import { render, staticRenderFns } from "./AccBookingDashboard.vue?vue&type=template&id=c977dd8e"
import script from "./AccBookingDashboard.vue?vue&type=script&lang=js"
export * from "./AccBookingDashboard.vue?vue&type=script&lang=js"
import style0 from "./AccBookingDashboard.vue?vue&type=style&index=0&id=c977dd8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports